import React from 'react';
import { motion } from 'framer-motion';

export default function About() {
  return (
    <section id="about" className="pt-24 pb-24 md:pt-32 md:pb-32 bg-[#111111] border-t border-[#222222]">
      <div className="container mx-auto px-8">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          <motion.div
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-orange/10 to-transparent rounded-3xl -rotate-3 scale-105 -z-10" />
            <img
              src="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80"
              alt="About Minotaur Solutions"
              className="w-full rounded-3xl shadow-2xl relative z-10 border border-[#2a2a2a] object-cover aspect-[4/3]"
            />
            <div className="absolute -bottom-6 -right-4 bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-5 shadow-xl z-20">
              <p className="text-brand-orange font-bold text-2xl">20+</p>
              <p className="text-gray-400 text-xs">Years of Expertise</p>
            </div>
            <div className="absolute -top-4 -left-4 bg-[#1a1a1a] border border-brand-orange/30 rounded-2xl p-5 shadow-xl z-20">
              <p className="text-brand-orange font-bold text-2xl">100%</p>
              <p className="text-gray-400 text-xs">Client Focused</p>
            </div>
          </motion.div>

          <motion.div
            className="w-full lg:w-1/2"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h5 className="text-brand-orange font-bold tracking-widest uppercase text-sm mb-4">About Us</h5>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
              Empowering Security,<br />Not Overwhelming It
            </h2>
            <div className="space-y-5 text-gray-300 text-lg leading-relaxed mb-10">
              <p>
                At Minotaur Solutions BV, we believe cybersecurity and data privacy should empower, not overwhelm.
                With advanced technology, customized solutions, and decades of expertise, we help businesses of all
                sizes navigate the complex world of cyber threats and compliance.
              </p>
              <p>
                From audits to privacy management to incident response, our mission is simple: to make cybersecurity
                and data protection easy, effective, and accessible for everyone.
              </p>
              <p className="font-semibold text-white italic border-l-4 border-brand-orange pl-5 mt-8">
                Minotaur Solutions BV: Your shield in the cybersecurity maze.
              </p>
            </div>
            <a href="#contact" className="btn-primary">Contact Us Today</a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}